import { useMobile } from "lib/@components/mobile"
import { Box, Typography } from "@mui/material"
import { childWhitespaceSx } from "routes/schedule/tasks/styles"
import { HighlightBox } from "lib/@components/highlightBox"
import { TaskBelow, TaskContent, TaskNotes } from "slot-definitions"
import { BoundEditableRichText } from "lib/@components/editable/editableRichText"
import { normalizeActions } from "library/normalizeActions.mjs"
import { If } from "lib/@components/switch"
import { fullTrim } from "routes/schedule/tasks/full-trim"
import { memo } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useTranslationContext } from "routes/schedule/plugins/translation/use-translation-context"

export const TaskDetailsEntry = memo(function TaskDetailsEntry({ sx, containerSx, item }) {
    const isMobile = useMobile()
    const { editMode } = useBoundContext()
    const { rtl, labels: translationLabels } = useTranslationContext()
    return (
        <Box
            data-cy="schedule-task-details"
            sx={{ ...childWhitespaceSx, ...containerSx }}
            width={1}
            mt={2}
            mb={3}
            pl={rtl ? 2 : isMobile ? 3 : 5}
            pr={rtl ? (isMobile ? 3 : 5) : 2}
            className="task-details-container"
        >
            <HighlightBox path="content">
                <TaskContent.Slot>
                    <BoundEditableRichText field="content" transformIn={normalizeActions} />
                </TaskContent.Slot>
            </HighlightBox>
            <TaskNotes.Slot>
                <If truthy={fullTrim(item.note) || editMode}>
                    <HighlightBox path="note" minWidth={300} sx={{ mt: 2, ...sx }} className="task-details-notes">
                        <Typography
                            component="div"
                            variant="overline"
                            className="task-details-notes-header"
                            gutterBottom
                        >
                            {translationLabels?.notes ?? "Notes"}
                        </Typography>
                        <BoundEditableRichText field="note" transformIn={normalizeActions} />
                    </HighlightBox>
                </If>
            </TaskNotes.Slot>
            <TaskBelow.Slot item={item} />
        </Box>
    )
})
